import http from '@/common/http';
export const request = (options) => new Promise((resolve, reject) => {
    http(options).then(res => {
        resolve(res);
    }).catch(e => {
        reject(e);
    });
});
